/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".overlay.clientUsersOverlay{height:100%}.overlay.clientUsersOverlay .ol-main.ol-main-users{background:#f5f5f5}.overlay.clientUsersOverlay .ol-main.ol-main-users .ol-content{height:100%}.overlay.clientUsersOverlay #submain .content.users{padding:10px 15px 15px!important;margin-bottom:50px}"];
export { styles as styles };
